import { Carousel } from "./_carousel";

window.addEventListener('load', () => {
  if (document.getElementById('home_slider')) {
    let homeCarousel = new Carousel("home_slider")
  }
})